import { ReactNode } from 'react';

import { useJourneyMachine } from 'machines/hooks/useJourneyMachine';
import { useResponsiveContext } from 'hooks/useResponsiveContext';
import { useComputeGuards } from 'machines/hooks/useComputeGuards';
import { XStateContext, ResponsiveContext } from 'components/app/AppContext';
import { useCaveatRegistry, ScreenContext } from 'hooks/useScreen';

type ContextsProps = {
  children: ReactNode;
};

const SyncGuards = ({ children }: ContextsProps) => {
  useComputeGuards();

  return children;
};

export const Contexts = ({ children }: ContextsProps) => {
  const { machine, actor } = useJourneyMachine();
  const machineContext = { machine, actor };
  const responsive = useResponsiveContext();
  const caveatRegistryContext = useCaveatRegistry();

  if (!machine || !actor) {
    return null;
  }

  return (
    <ResponsiveContext.Provider value={responsive}>
      <XStateContext.Provider value={machineContext}>
        <SyncGuards>
          <ScreenContext.Provider value={{ ...caveatRegistryContext }}>
            {children}
          </ScreenContext.Provider>
        </SyncGuards>
      </XStateContext.Provider>
    </ResponsiveContext.Provider>
  );
};
